export default __webpack_public_path__ + "static/media/order-service-bullets-active.cbe46a8c.svg";